module.exports = __webpack_public_path__ + "img/avr2025.50c7ff38.png";